import React, {Fragment} from 'react'
import Button from 'orionsoft-parts/lib/components/Button'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import MdPhoneIcon from 'react-icons/lib/md/phone'
import useMutate from 'apollo-hooks/lib/useMutate'
import gql from 'graphql-tag'

import styles from './styles.css'

const badgeColors = (currentCallPhoneNumber, vehiclePhoneNumber) => {
  if (currentCallPhoneNumber === vehiclePhoneNumber) {
    return styles.green
  }
  return styles.gray
}
const badgeTooltips = (currentCallPhoneNumber, vehiclePhoneNumber) => {
  if (currentCallPhoneNumber === vehiclePhoneNumber) {
    return 'Finalizar llamada'
  }
  return 'Llamar al repartidor'
}

export default function CallDriver({
  phone,
  currentCallPhoneNumber,
  makeCall,
  stopCall,
  tooltipPlace = 'top',
  label = null,
  order,
  vehicleCode
}) {
  const mutate = useMutate()

  const logCall = async phone => {
    if (!order) return
    try {
      await mutate({
        mutation: gql`
          mutation logCall($orderId: ID, $phone: String, $toDriver: Boolean, $vehicleCode: String) {
            logCall(
              orderId: $orderId
              phone: $phone
              toDriver: $toDriver
              vehicleCode: $vehicleCode
            )
          }
        `,
        variables: {orderId: order._id, phone, toDriver: true, vehicleCode}
      })
    } catch (error) {
      alert(error.message)
    }
  }

  const onStopCall = async (start, end) => {
    if (!order) return

    const duration = end.diff(start, 'seconds')

    try {
      await mutate({
        mutation: gql`
          mutation logCallFinished($orderId: ID, $duration: Float, $vehicleCode: String) {
            logCallFinished(orderId: $orderId, duration: $duration, vehicleCode: $vehicleCode)
          }
        `,
        variables: {orderId: order._id, duration, vehicleCode}
      })
    } catch (error) {
      alert(error.message)
    }
  }

  if (!phone) return null

  const badgeTooltip = badgeTooltips(currentCallPhoneNumber, phone)

  return (
    <Fragment>
      <Tooltip content={badgeTooltip} place={tooltipPlace}>
        <Button
          disabled={currentCallPhoneNumber && currentCallPhoneNumber !== phone}
          onClick={() => {
            if (currentCallPhoneNumber === phone) {
              stopCall(phone)
            } else {
              makeCall(phone, onStopCall)
              logCall(phone)
            }
          }}>
          <span className={styles.chat}>
            {label ? <span className={styles.label}>{label}</span> : null}
            <MdPhoneIcon />
          </span>
          <span className={`${styles.badge} ${badgeColors(currentCallPhoneNumber, phone)}`}></span>
        </Button>
      </Tooltip>
    </Fragment>
  )
}
